import React, { useCallback, memo } from 'react';
import { get } from 'lodash';
import i18n from 'i18n';
import Button from 'components/Button';
import PlayIcon from 'components/Icons/play';
import WatchlistIcon from 'components/Icons/watchlist';
import TrailerIcon from 'components/Icons/trailer';
import { ActionButtonsWrapper } from './StyledComponents';

const playButtonId = 'details-play-button';
const watchlistButtonId = 'details-watchlist-button';
const trailerButtonId = 'details-trailer-button';

const WatchControls = (props) => {
  const { data, sectionName, isVisible, isExpandDescriptionButtonVisible } = props;
  const { onFocus, onPlay, onFavorite } = props;
  const isInFavorite = !!data.favorite;
  const trailerUrl = get(data, ['previewContentUrls', 'trailer']);

  const onEnter = useCallback(
    ({ id }) => {
      let type = null;
      if (id === playButtonId) type = 'play';
      if (id === trailerButtonId) type = 'trailer';
      onPlay({ type, id });
    },
    [onPlay],
  );

  return (
    <ActionButtonsWrapper
      id="ActionButtonsWrapper"
      isVisible={isVisible}
      sectionName={sectionName}
      config={{
        preventMouseNavigateWithin: true,
        leaveFor: {
          up: '@BACK_BUTTON',
          down: isExpandDescriptionButtonVisible ? '@EXPAND_DESCRIPTION_BUTTON' : '@COVER',
          right: '@COVER',
        },
      }}
      defaultSection
    >
      <Button
        onFocus={onFocus}
        onEnter={onEnter}
        id={playButtonId}
        payload={{ id: playButtonId }}
        focusOnMouseEnter
      >
        <PlayIcon key="play" /> {i18n.t('detailsVOD.watch')}
      </Button>
      <Button
        onFocus={onFocus}
        onEnter={onFavorite}
        id={watchlistButtonId}
        isActive={isInFavorite}
        focusOnMouseEnter
      >
        <WatchlistIcon />
        {isInFavorite ? i18n.t('detailsVOD.watchlistRemove') : i18n.t('detailsVOD.watchlistAdd')}
      </Button>
      {trailerUrl ? (
        <Button
          onFocus={onFocus}
          onEnter={onEnter}
          id={trailerButtonId}
          payload={{ id: trailerButtonId }}
          focusOnMouseEnter
        >
          <TrailerIcon />
          {i18n.t('detailsVOD.trailer')}
        </Button>
      ) : null}
    </ActionButtonsWrapper>
  );
};

export default memo(WatchControls);
